import React, { FC } from 'react';
import { InternalProjectDetails } from '../shared/internal-project';
import { ResponsiveSize } from '../PortfolioProjectCard/Layout';
import { AttachmentsBadge } from './AttachmentsBadge';
import { MadeOnFiverrBadge } from './MadeOnFiverrBadge';

interface BadgeProps {
  attachmentsCount?: number;
  internalProjectDetails?: InternalProjectDetails;
  size: ResponsiveSize;
}

export const PortfolioProjectBadge: FC<BadgeProps> = ({ attachmentsCount, size, internalProjectDetails }) => {
  if (internalProjectDetails) {
    return <MadeOnFiverrBadge size={size} />;
  }

  return <AttachmentsBadge totalCount={attachmentsCount} size={size} />;
};
